import { Component, computed, effect, inject, input, signal, untracked } from '@angular/core';
import { ChartApiService } from '@app/+authenticated/chart';
import { TranslatePipe } from '@ngx-translate/core';
import { ChartComponent } from '@sb/ui/chart';
import { DashboardWidgetComponent } from '@sb/ui/dashboard-widget/dashboard.widget.component';
import { Subscription } from 'rxjs';

import { GraphSize } from '../../enums';
import { ChartPayload } from '../../models';
import { ChartHelperService, ChartLineChart } from '../../services/chart-helper.service';

@Component({
  selector: 'app-worked-hours-graph',
  templateUrl: './worked-hours-graph.component.html',
  imports: [ChartComponent, TranslatePipe, DashboardWidgetComponent],
})
export class WorkedHoursGraphComponent {
  private chartHelper = inject(ChartHelperService);
  private chartApi = inject(ChartApiService);

  chartPayload = input.required<ChartPayload>();
  size = input<GraphSize>('medium');

  height = computed(() => this.chartHelper.getHeight(this.size()));

  chart = signal<ChartLineChart>(undefined);
  isLoading = signal(false);

  private loadSubscription: Subscription | undefined;

  constructor() {
    effect((onCleanUp) => {
      const payload = this.chartPayload();

      untracked(() => {
        this.loadData(payload);
      });

      onCleanUp(() => {
        this.loadSubscription?.unsubscribe();
      });
    });
  }

  private loadData(payload: ChartPayload): void {
    this.isLoading.set(true);

    this.loadSubscription?.unsubscribe();

    this.loadSubscription = this.chartApi.schedule(payload).subscribe((chartResponse) => {
      this.chart.set(
        this.chartHelper.convertToLineChart(
          chartResponse.labels,
          chartResponse.differences,
          (difference) => difference.difference_percentage,
        ),
      );
      this.isLoading.set(false);
      this.loadSubscription = undefined;
    });
  }
}
